"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneView = void 0;
const View_1 = __importDefault(require("../View"));
function cloneView(s) {
    const c = new View_1.default();
    c.id = s.id;
    c.isSystem = s.isSystem;
    c.isOwned = s.isOwned;
    c.isShared = s.isShared;
    c.isDashboard = s.isDashboard;
    c.title = s.title;
    c.type = s.type;
    c.sortBy = s.sortBy;
    c.sortByDesc = s.sortByDesc;
    c.pinField = s.pinField;
    c.filters = s.filters;
    c.groupBys = s.groupBys;
    c.autoRefresh = s.autoRefresh;
    c.hideEmptyGroups = s.hideEmptyGroups;
    c.highlightedGroups = s.highlightedGroups;
    c.highlightedDateRange = s.highlightedDateRange;
    c.highlightedField = s.highlightedField;
    c.highlightedItem = s.highlightedItem;
    c.chartBox = s.chartBox;
    c.fields = s.fields;
    c.fieldsChanged = s.fieldsChanged;
    c.filtersChanged = s.filtersChanged;
    c.groupsChanged = s.groupsChanged;
    c.sortingChanged = s.sortingChanged;
    c.pinningChanged = s.pinningChanged;
    c.highlightsChanged = s.highlightsChanged;
    c.chartsChanged = s.chartsChanged;
    c.reportPage = s.reportPage;
    return c;
}
exports.cloneView = cloneView;
exports.default = cloneView;
